import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveSnowOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'
import strap from './shared-straps.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    whiteM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_whiteM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_whiteM-{nnn}.png',
    },
    beigeM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_beigeM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_beigeM-{nnn}.png',
    },
    blackM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_blackM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_blackM-{nnn}.png',
    },
    greyM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_greyM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_greyM-{nnn}.png',
    },
    rustM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_rustM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_rustM-{nnn}.png',
    },
    purpleM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_purpleM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_purpleM-{nnn}.png',
    },
    tealM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_tealM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_tealM-{nnn}.png',
    },
    pinkM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_pinkM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_pinkM-{nnn}.png',
    },
    blushM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_blushM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_blushM-{nnn}.png',
    },
    sandM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_sandM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_sandM-{nnn}.png',
    },
    navyM: {
      pathTemplate: 'gs://sg360/251202/snipers/frame/snf_navyM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/snipers/frame/snf_navyM-{nnn}.png',
    },
    sageM: {
      pathTemplate: 'gs://sg360/261019/sf_sage-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/sf_sage-{nnn}.png',
    },
    none: {
      pathTemplate: 'gs://sg360/251217/ghost/snf_ghost-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/ghost/snf_ghost-{nnn}.png',
    },
  },
}

export const lens = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    silverblueN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_silverblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_silverblueN-{nnn}.png',
    },
    silverblue8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8silverblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8silverblueN-{nnn}.png',
    },
    fireN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_fireN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_fireN-{nnn}.png',
    },
    fire8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8fireN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8fireN-{nnn}.png',
    },
    clearN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_clearN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_clearN-{nnn}.png',
    },
    clear8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8clearN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8clearN-{nnn}.png',
    },
    greenN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_greenN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_greenN-{nnn}.png',
    },
    green8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8greenN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8greenN-{nnn}.png',
    },
    purpleN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_purpleN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_purpleN-{nnn}.png',
    },
    purple8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8purpleN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8purpleN-{nnn}.png',
    },
    pinkN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_pinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_pinkN-{nnn}.png',
    },
    pink8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8pinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8pinkN-{nnn}.png',
    },
    smokeN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_smokeN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_smokeN-{nnn}.png',
    },
    smoke8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8smokeN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8smokeN-{nnn}.png',
    },
    chromeN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_chromeN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_chromeN-{nnn}.png',
    },
    chrome8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8chromeN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8chromeN-{nnn}.png',
    },
    hvblueN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_hvblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_hvblueN-{nnn}.png',
    },
    hvblue8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8hvblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8hvblueN-{nnn}.png',
    },
    hvpinkN: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_hvpinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_hvpinkN-{nnn}.png',
    },
    hvpink8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8hvpinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/snipers/snle_8hvpinkN-{nnn}.png',
    },
    none: {
      pathTemplate: 'gs://sg360/251217/ghost/snle_ghost-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/ghost/snle_ghost-{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  return {
    frame: getSKUWithoutPrefix(customisedProduct.frameChoice?.sku),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice?.sku),
    strap: getSKUWithoutPrefix(customisedProduct.strapChoice?.sku),
  }
}

export default {
  layers: [strap, frame, lens],
  resolveOptions,
  resolveOptionsFromSKU,
}
